import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：标签表】
 * 生成日期：2025/11/06 14:34:21
 * 生成路径: src/api/tag.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getTagList(data) {
  return request.post('/tag/list', data)
}
/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveTag(data) {
  return request.post('/tag/store', data)
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getTagInfo(id) {
  let data = { id: id }
  return request.post('/tag/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryTagInfo(where) {
  return request.post('/tag/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteTag(id) {
  let data = { id: id }
  return request.post('/tag/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importTags(data) {
  return request.post('/tag/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportTags(data) {
  return request.postBlob('/tag/export', data)
}